/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Tpl_SubInputs */

const en_fw_tpl_sub = /** @type {(inputs: Fw_Tpl_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every template here comes from a real plan with at least 5 verified tasks. Ranked by pass rate, not by popularity.`)
};

const id_fw_tpl_sub = /** @type {(inputs: Fw_Tpl_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setiap template di sini berasal dari rencana nyata dengan minimal 5 task terverifikasi. Diurutkan berdasarkan pass rate, bukan popularitas.`)
};

/**
* | output |
* | --- |
* | "Every template here comes from a real plan with at least 5 verified tasks. Ranked by pass rate, not by popularity." |
*
* @param {Fw_Tpl_SubInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_tpl_sub = /** @type {((inputs?: Fw_Tpl_SubInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Tpl_SubInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_tpl_sub(inputs)
	return en_fw_tpl_sub(inputs)
});